import {useCallback, useContext} from "react";

import {LearningTimeInfoApiContext} from "./internal/learning-time-info-api-context.ts";
import {markConversion} from "./internal/mark-conversion.ts";
import type {Conversion, MarkConversionT} from "./types.ts";

/**
 * Obtain a function for submitting conversions.
 *
 * This provides a  stable `markConversion` function, used
 * to submit conversions with the current learning
 * time context.
 *
 * @returns A stable function for marking a conversion.
 */
export const useMarkConversion = (): MarkConversionT => {
    const learningTimeInfoApi = useContext(LearningTimeInfoApiContext);

    return useCallback(
        (conversion: Conversion | ReadonlyArray<Conversion>) =>
            markConversion(conversion, learningTimeInfoApi.combinedLti),
        [learningTimeInfoApi],
    );
};
